import { getSession } from "next-auth/react";

import Mixpanel from "@src/mixpanel";

import api from "@src/api/index";

const mp = Mixpanel;

export const identityLoggedUser = async () => {
  const session = await getSession();

  if (!session) {
    return;
  }

  const {
    user: {
      email: sessionEmail,
      image: { source, access_token },
    },
  } = session;

  if (source === "fromLatam") {
    return;
  }

  const user = await api.getUserByEmail(sessionEmail);

  const {
    id,
    id_beyond,
    name,
    lastname,
    scndlastname,
    email,
    is_mixpanel_registered,
    ...rest
  } = user;

  const superProperties = {
    email,
    name,
    lastname,
    scndlastname,
    id_beyond,
    ...rest,
  };

  mp.init();
  mp.createSuperProperties(superProperties);
  mp.indentifyUser({ user: email });

  if (!is_mixpanel_registered) {
    const profileOptions = {
      id_beyond,
      $email: email,
      name: `${name} ${lastname} ${scndlastname}`,
      ...rest,
    };
    mp.setProfile({ options: profileOptions });
    await api.updateUserMixpanelRegistered(true, access_token);
  }
};
